import React, { useState, useEffect, Component } from "react";
import Cookies from "js-cookie";
import BASE_URL from "../config";
import Table from "react-bootstrap/Table";
import axios from "axios";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Container } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactPaginate from "react-paginate";

const InvoiceApproval = (props) => {
  const storedToken = Cookies.get("authToken");
  const storedUser = Cookies.get("authUser");
  const [authtoken, setAuthToken] = useState(storedToken || "");
  const [authUser, setAuthUser] = useState(storedUser || "");
  const [pageComponent, setPageComponent] = useState("invoice");
  const [invoiceList, setInvoiceList] = useState(undefined);
  const [selectedRows, setSelectedRows] = useState([]);
  const headercolumns = [
    "Invoice No",
    "BL No",
    "Cost Amount",
    "Quote Amount",
    "Profit",
    "Select",
    "View",
    "Remark",
  ];
  const columns = [
    "invoice_number",
    "bill_number",
    "total_cost",
    "total_quote",
    "profit",
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(15);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentItems =
    invoiceList !== undefined
      ? invoiceList.slice(indexOfFirstPost, indexOfLastPost)
      : undefined;

  const paginate = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  useEffect(() => {
    fetch(`${BASE_URL}${pageComponent}/pending_data`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setInvoiceList(data.pending_invoice_numbers);
        // setData(data.);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [authtoken]);

  const handleCheckboxChange = (event, id) => {
    if (event.target.checked) {
      setSelectedRows([...selectedRows, id]);
    } else {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    }
  };

  const handleSave = async (event) => {
    event.preventDefault();
    if (selectedRows === "") {
      toast.error("Please Select Invoice", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      const datalist = [];
      selectedRows.forEach((ivoItem) => {
        const invoiceItems = {
          invoice_header_id: ivoItem,
          approval_status: 1,
        };
        datalist.push(invoiceItems);
      });

      const selectedInvoice = {
        invoice_id_values: datalist,
      };
      axios
        .post(
          `${BASE_URL}${pageComponent}/approve`,
          JSON.stringify(selectedInvoice, null, 2),
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            toast.success("Successfully Save Data ! ", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        .catch((error) => {
          console.error(error);
          alert(error);
          console.log(datalist);
        });
    }
  };

  const handleReject = async (event) => {
    event.preventDefault();
    if (selectedRows === "") {
      toast.error("Please Select Booking", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      const datalist = [];
      selectedRows.forEach((ivoItem) => {
        const invoiceItems = {
          invoice_header_id: ivoItem,
          approval_status: 2,
        };
        datalist.push(invoiceItems);
      });

      const selectedInvoice = {
        invoice_id_values: datalist,
      };
      axios
        .post(
          `${BASE_URL}${pageComponent}/approve`,
          JSON.stringify(selectedInvoice, null, 2),
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            toast.success("Successfully Save Data ! ", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setTimeout(() => {
              window.location.reload(); // Reload the page after deletion
            }, 2000);
          }
        })
        .catch((error) => {
          console.error(error);
          alert(error);
          console.log(datalist);
        });
    }
  };

  return (
    <Container fluid>
      <ToastContainer autoClose={2000} />
      <Row>
        <Table className="mt-2" responsive hover size="sm" striped="columns">
          <thead>
            <tr>
              {columns !== null
                ? headercolumns.map((column) => (
                  <th className="text-center" key={column.id}>
                    {column}
                  </th>
                ))
                : ""}
            </tr>
          </thead>
          <tbody>
            {currentItems !== undefined ? (
              currentItems.map((row, index) => (
                // <tr key={row.id} onClick={() => setSelectedRow(index,row)}>
                <tr key={row.id}>
                  {columns.map((column) => (
                    <td className="text-center" key={column}>
                      {row[column]}
                    </td>
                  ))}
                  <td className="text-center">
                    <input
                      inline
                      label="1"
                      name="group1"
                      type={"checkbox"}
                      className="text-center"
                      onChange={(event) => handleCheckboxChange(event, row.id)}
                    />
                  </td>
                  <td>
                    <Button className="ms-3" variant="primary" type="submit">
                      View
                    </Button>
                  </td>
                  <td>
                    <input type="text"></input>
                  </td>
                </tr>
              ))
            ) : (
              <div>Loading...</div>
            )}
          </tbody>
        </Table>
        <ReactPaginate
          onPageChange={paginate}
          pageCount={
            invoiceList !== undefined
              ? Math.ceil(invoiceList.length / postsPerPage)
              : ""
          }
          previousLabel={"Prev"}
          nextLabel={"Next"}
          containerClassName={"pagination"}
          pageLinkClassName={"page-number"}
          previousLinkClassName={"page-number"}
          nextLinkClassName={"page-number"}
          activeLinkClassName={"active"}
        />
      </Row>
      <Row className="text-center mt-3">
        <Col className="text-end">
          {props.selectedAuthority && props.selectedAuthority.approve === 1 ? (
            <>
              <Button
                className="ms-3 p-2"
                variant="primary"
                onClick={handleSave}
              >
                Approve
              </Button>
              <Button
                className="ms-3 p-2"
                variant="primary"
                onClick={handleReject}
              >
                Reject
              </Button>
            </>
          ) : null}
        </Col>
      </Row>
    </Container>
  );
};

export default InvoiceApproval;